import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./Profile.css";
import { useLicense } from "../../../context/licenseContext";
import { useToast } from "../../../context/toastContext";
import PieChart from "../../../components/PieChart/PieChart";
import EditProfile from "../../../components/EditProfile/editProfile";

import apiClient from "../../../api/apiClient";

const Profile = ({ userId, rank, updated, setUpdated, setHeaderTitle }) => {
    const currentLicense = useLicense().currentLicense;
    const toast = useToast();
    const [showProfile, setShowProfile] = useState(true);
    const [activeTable, setActiveTable] = useState("profiles");
    const { id } = useParams();
    const [coas, setCoas] = useState([]); //stores COAs
    const [yellow, setYellow] = useState(0); //stores yellow color count
    const [purple, setPurple] = useState(0); //stores purple color count
    const [green, setGreen] = useState(0); //stores green color count
    const [blue, setBlue] = useState(0); //stores blue color count
    const [noColor, setNoColor] = useState(0); //
    const [synthetic, setSynthetic] = useState(0); //stores synthetic color count
    const [navy, setNavy] = useState(0); //stores navy color count
    const [showEmployees, setShowEmployees] = useState(false);
    const [showEditProfile, setShowEditProfile] = useState(false);
    const [licenses, setLicenses] = useState([]);
    const [title, setTitle] = useState();
    const [companyName, setCompanyName] = useState("");
    const [licenseNumber, setLicenseNumber] = useState("");
    const [instagram, setInstagram] = useState("");
    const [facebook, setFacebook] = useState("");
    const [website, setWebsite] = useState("");
    const [twitter, setTwitter] = useState("");
    const [linkedin, setLinkedin] = useState("");
    const [userProfile, setUserProfile] = useState("");
    const [canUserEditCompanyProfile, setCanUserEditCompanyProfile] = useState(false);
    const [profilePic, setProfilePic] = useState(null);
    const [street, setStreet] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [zip, setZip] = useState("");
    const [employees, setEmployees] = useState([]);
    const [description, setDescription] = useState("");
    const [images, setImages] = useState([]);
    const [industry, setIndustry] = useState("");
    const navigate = useNavigate(); // Initialize useNavigate

    const nonAdminEmployees = employees.filter((employee) => employee.title !== "admin");

    const getCoas = async () => {
        const response = await apiClient.get(`/coas/coa-colors-by-license?licenseNo=${id}`);
        console.log(response.data);
        setCoas(response.data);
        let yellowCount = 0;
        let purpleCount = 0;
        let greenCount = 0;
        let blueCount = 0;
        let noneCount = 0;
        let syntheticCount = 0;
        let navyCount = 0;

        for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].color === "yellow") {
                yellowCount++;
            } else if (response.data[i].color === "purple") {
                purpleCount++;
            } else if (response.data[i].color === "green") {
                greenCount++;
            } else if (response.data[i].color === "blue") {
                blueCount++;
            } else if (response.data[i].color === "no color") {
                noneCount++;
            } else if (response.data[i].color === "synthetic") {
                syntheticCount++;
            } else if (response.data[i].color === "navy") {
                navyCount++;
            }
        }

        setYellow(yellowCount);
        setPurple(purpleCount);
        setGreen(greenCount);
        setBlue(blueCount);
        setNoColor(noneCount);
        setSynthetic(syntheticCount);
        setNavy(navyCount);
    };

    //default handler for clicking links
    const handleClickNoLink = async (e) => {
        e.preventDefault();
        toast.info("User has not added a link yet");
    };

    const employeesList = () => {
        apiClient.get(`/user/get-employees-from-id?licenseNo=${id}`).then((response) => {
            setEmployees(response.data);
        });
    };

    //fetches inforrmation of whoevers profile you are on
    useEffect(() => {
        apiClient
            .get(`/license/get-by-license/${id}`)
            .then((response) => response.data)
            .then((data) => {
                setCompanyName(data[0].company);
                setLicenseNumber(data[0].licenseNo);
                setInstagram(data[0].instagram);
                setLinkedin(data[0].linkedIn);
                setFacebook(data[0].facebook);
                setTwitter(data[0].twitter);
                setWebsite(data[0].website);
                setUserProfile(data[0].profile);
                setStreet(data[0].address);
                setCity(data[0].city);
                setState(data[0].state);
                setIndustry(data[0].industry);
                setZip(data[0].zipCode);
                setProfilePic(data[0].logo);
                setDescription(data[0].description);
                setCanUserEditCompanyProfile(data[0].can_edit_company_profile);
                if (data[0].companyPics) {
                    setImages(data[0].companyPics);
                } else {
                    setImages([]);
                }
                setHeaderTitle(data[0].company);
            })
            .catch((error) => {
                console.error("Error:", error);
            });
        console.log("CAN USER EDIT COMPANY ", canUserEditCompanyProfile);
    }, [id]);

    let count = 0;
    useEffect(() => {
        if (count === 0) {
            getUserInfo();
            employeesList();
            getCoas();
            count++;
        }
    }, [id]);

    const getUserInfo = async () => {
        try {
            setTitle(currentLicense.title);
            const userResponse = await apiClient.get(`/user/get-user-info`);
            const currentUser = await userResponse.data;
            // Fetch licenses for each license number in currentUser.licenses
            const licensePromises = currentUser.licenseNo.map((licenseNo) =>
                apiClient.get(`/license/get-by-license/${licenseNo}`)
            );

            // Wait for all license requests to complete
            const licenseResponses = await Promise.all(licensePromises);

            // Extract data from each response
            const licensesData = licenseResponses.map((response) => response.data);
            //take licenseNos from licensesData and store them in an array
            const licenseNumbers = licensesData.map((license) => license.licenseNo);
            const flattenedLicensesData = licenseNumbers.flat(Infinity);

            setLicenses(licenseNumbers);
        } catch (error) {
            console.error("Error fetching user info:", error);
        }
    };

    const toggleProfile = () => {
        setShowProfile(true);
        setActiveTable("profiles");
        setShowEditProfile(false);
    };

    const toggleEditProfile = () => {
        setShowProfile(false);
        setActiveTable("editProfile");
        setShowEditProfile(true);
    };

    return (
        <div className="fade-down">
            {showEmployees && (
                <div className="employee-list">
                    <div className="employee-list-box">
                        <h3 className="employee-list-title">Employees</h3>
                        <table className="PendingFriendsUsers" style={{ overflow: "auto", width: "100%" }}>
                            <tbody>
                                {nonAdminEmployees.map((friend, index) => (
                                    <tr key={index} className="table-row-friends">
                                        <td
                                            style={{
                                                width: "20vw",
                                                textAlign: "left",
                                                padding: "1vh 1vw",
                                                fontWeight: "bold",
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            <div className="profile-container-username-and-pic">
                                                {!friend.profilePic && (
                                                    <img
                                                        onClick={() => {
                                                            navigate(`/userProfile/${friend.userId}`);
                                                        }}
                                                        src="/ProfilePicDefault.svg"
                                                        alt="Profile"
                                                        className="profile-pic-container-1"
                                                    />
                                                )}
                                                {friend.profilePic && (
                                                    <img
                                                        onClick={() => {
                                                            navigate(`/userProfile/${friend.userId}`);
                                                        }}
                                                        src={friend.profilePic}
                                                        alt="Profile"
                                                        className="profile-pic-container-1"
                                                        // style={{ width: "1vw" }}
                                                    />
                                                )}
                                                <button
                                                    onClick={() => {
                                                        navigate(`/userProfile/${friend.userId}`);
                                                    }}
                                                    className="go-to-friend"
                                                >
                                                    {friend.firstName} {friend.lastName}
                                                </button>
                                            </div>
                                        </td>
                                        <td style={{ padding: "1vh 2vw" }}>{friend.title}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className="close-employee-list" onClick={() => setShowEmployees(false)}>
                            X
                        </div>
                        <div className="employee-list-content"></div>
                    </div>
                </div>
            )}
            <div className="dash">
                <div className="dash-content-profile">
                    {showEditProfile && (
                        <EditProfile
                            toggleProfile={toggleProfile}
                            images={images}
                            setImages={setImages}
                            userId={userId}
                            companyName={companyName}
                            setCompanyName={setCompanyName}
                            instagram={instagram}
                            setInstagram={setInstagram}
                            facebook={facebook}
                            setFacebook={setFacebook}
                            website={website}
                            setWebsite={setWebsite}
                            twitter={twitter}
                            setTwitter={setTwitter}
                            linkedin={linkedin}
                            setLinkedin={setLinkedin}
                            userProfile={userProfile}
                            setUserProfile={setUserProfile}
                            profilePic={profilePic}
                            setProfilePic={setProfilePic}
                            street={street}
                            setStreet={setStreet}
                            city={city}
                            setCity={setCity}
                            setShowEditProfile={setShowEditProfile}
                            state={state}
                            setState={setState}
                            zip={zip}
                            setZip={setZip}
                            description={description}
                            setDescription={setDescription}
                            setUpdated={setUpdated}
                            updated={updated}
                            rank={rank}
                            licenseNo={id}
                            setShowProfile={setShowProfile}
                        />
                    )}
                    {showProfile && (
                        <>
                            <div
                                className="profile-container fade-down"
                                style={userId === id ? { width: "80vw" } : { width: "80vw" }}
                            >
                                <div className="profile-title">
                                    <span className="company-name-profile">{companyName}</span> {/*profile Picture */}
                                    {!profilePic && (
                                        <img src="/ProfilePicDefault.svg" alt="Profile" className="profile-pic" />
                                    )}
                                    {profilePic && (
                                        <div className="image-upload">
                                            <img src={profilePic} alt="Profile" className="profile-pic" />
                                        </div>
                                    )}
                                    {description && (
                                        <p
                                            style={{
                                                marginTop: "5vh",
                                                fontSize: "1em",
                                                width: "20vw",
                                                fontWeight: "bold",
                                                whiteSpace: "pre-wrap",
                                                tabSize: 4,
                                            }}
                                        >
                                            {description}
                                        </p>
                                    )}
                                </div>
                                <div className="pie-chart-profile">
                                    <PieChart data={[yellow, green, blue, navy, purple, noColor, synthetic]} />
                                </div>
                                <div className="social-links" style={{ boxShadow: "none" }}>
                                    {currentLicense.licenseNo === id && (
                                        <button
                                            onClick={toggleEditProfile}
                                            className={`employeeButton`}
                                            style={{
                                                marginBottom: "2vh",
                                            }}
                                            disabled={!canUserEditCompanyProfile}
                                        >
                                            Edit Profile
                                        </button>
                                    )}

                                    <button onClick={() => setShowEmployees(true)} className="employeeButton">
                                        Employees
                                    </button>
                                    {/* <button onClick={openEmployees}></button> */}
                                    {(linkedin || twitter || instagram || facebook || website) && (
                                        <h2 className="center-text">Find us online</h2>
                                    )}
                                    {/* social media links */}
                                    <div className="social-links-container">
                                        {linkedin && (
                                            <a href={linkedin} target="_blank" rel="noopener noreferrer">
                                                <img src="/social-link/linkedin-01.svg" alt="LinkedIn" />
                                            </a>
                                        )}
                                        {twitter && (
                                            <a href={twitter} target="_blank" rel="noopener noreferrer">
                                                <img src="/social-link/twitter-01.svg" alt="Twitter" />
                                            </a>
                                        )}
                                        {instagram && (
                                            <a href={instagram} target="_blank" rel="noopener noreferrer">
                                                <img src="/social-link/insta-01.svg" alt="Instagram" />
                                            </a>
                                        )}
                                        {facebook && (
                                            <a href={facebook} target="_blank" rel="noopener noreferrer">
                                                <img src="/social-link/facebook-01.svg" alt="Facebook" />
                                            </a>
                                        )}
                                        {website && (
                                            <a href={website} target="_blank" rel="noopener noreferrer">
                                                <img src="/social-link/014-website.svg" alt="website" />
                                            </a>
                                        )}
                                    </div>
                                    {/* public company info */}
                                    <div className="occupation-info">
                                        <h3 className="info-section-header">Company information</h3>
                                        <div className="additional-info">
                                            <p>
                                                <strong>Company:</strong> {companyName}
                                            </p>
                                            <p>
                                                <strong>Company Type:</strong> {userProfile}
                                            </p>
                                            <p>
                                                <strong>Industry:</strong> {industry}
                                            </p>
                                            <p>
                                                <strong>State:</strong> {state}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Profile;
